var render = function render(){var _vm=this,_c=_vm._self._c;return _c('role-index',{attrs:{"title":"Roles de Onboarding","onboarding":"","admin":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }